import axios from 'axios'
import {config} from '../config'
const domain = config()['sls-api-url']
const txdomain = config()['tourneyx-url']

//Added by naveen - for API call option value from DB
export const getImageSourceOption = async ( option_name, http = axios) => {
  const url = `${domain}/api/v2/get_value_by_option_name`;

  return http.post(url,{'option_name': option_name})
      .then(response => response.data)
      .catch(error => Promise.reject(`Error retrieving Option Name: ${error}`))
}

// Get tournament details from slug url, instead of tournament_id

export const getTournamentDetails = async (slug, http = axios) => {
  const url = `${domain}/api/v2/get_react_page_tournament_details`;

  return http.post(url, {'slug': slug})
    .then(response => response.data)
    .catch(error => Promise.reject(`Error retrieving standings: ${error}`))
}

// Get daily big fish, hourly big fish records 
export const getBigFish = async (tournamentId, http = axios) => {
  const url = `${domain}/api/v2/get_daily_big_fish` 

  return http.post(url,{'tournamentId': tournamentId})
    .then(response => response.data)
    .catch(error => Promise.reject(`Error retrieving big fish: ${error}`))
}

// Get standing records to be shown on public-leaderboard page
export const getStandings = async (tournamentId, http = axios) => {
  const url = `${domain}/api/v2/post_tournament_standings_summary` 

  return http.post(url,{'tournamentId': tournamentId})
    .then(response => response.data)
    .catch(error => Promise.reject(`Error retrieving big fish: ${error}`))
}

// Get team-type tournament standing records to be shown on public-leaderboard page
export const getTeamStandings = async (tournamentId, http = axios) => {
  const url = `${domain}/api/v2/get_react_site_team_standings` 

  return http.post(url,{'tournamentId': tournamentId})
    .then(response => response.data)
    .catch(error => Promise.reject(`Error retrieving big fish: ${error}`))
}

// Get mini-games tournament type standing records to be shown on public-leaderboard page
export const getMiniTeamGroups = async (tournamentId, http = axios) => {
  const url = `${domain}/api/v2/get_group_records_for_mini_team` 

  return http.post(url,{'tournamentId': tournamentId})
    .then(response => response.data)
    .catch(error => Promise.reject(`Error retrieving mini-team groups: ${error}`))
}

// Get slam-type standing records to be shown on public-leaderboard page
export const getSlamStandings = async (tournamentId, http = axios) => {
  const url = `${domain}/api/v2/get_react_site_slam_standings` 

  return http.post(url,{'tournamentId': tournamentId})
    .then(response => response.data)
    .catch(error => Promise.reject(`Error retrieving big fish: ${error}`))
}

// Get logged in user details from the site
// If he is logged into the site already, check if he is a regular user,admin or director based on his session-token
export const getLoggedInUserDetails = async (http=axios) => {
  const url = `${txdomain}/app/lib/php/get-session-value`;

  return http.get(url)
  .then(response => response.data)
  .catch(error => Promise.reject(`Error retrieving logged in user data: ${error}`))
}

// Log the user out from the site
// This clears the session token and user is logged out from the site
export const logoutUserFromSite = async (user_id,http = axios) => {
  const url = `${txdomain}/app/lib/php/clear-session-value.php?a=logOutUser&user_id=${user_id}`;

  return http.get(url)
  .then(response => response.data)
  .catch(error => Promise.reject(`Error retrieving logged out user data: ${error}`))

}

// Get logged in users pinned tournaments
export const getAnglerPinnedTournaments = async (user_id, http = axios) => {
  const url = `${domain}/api/v2/get_angler_pinned_tournaments` 

  return http.post(url,{'anglerId': user_id})
  .then(response => response.data)
  .catch(error => Promise.reject(`Error retrieving big fish: ${error}`))

}

// To show upcoming tournament countdown, only gets first tournament record 
export const getUpComingTourneyCountdown = async (http=axios) => {
  const url = `${domain}/api/v2/get_upcoming_tourney_countdown` 
  const user_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return http.post(url,{'user_timezone': user_timezone})
  .then(response => response.data)
  .catch(error => Promise.reject(`Error retrieving big fish: ${error}`))

}

// Marked the viewed tournament as pinned tournament for the loggedin user
export const setPinnedTournament  = async (tournament_id, angler_id, http = axios) => {
  const url = `${domain}/api/v2/set_tournament_pinned`
  
  return http.post(url,{'tournament_id': tournament_id,'angler_id':angler_id})
  .then(response => response.data)
  .catch(error => Promise.reject(`Error retrieving big fish: ${error}`))
}

// Marked the viewed tournament as un-pinned tournament for the loggedin user
export const unpinSelectedTournament  = async (tournament_id, angler_id, http = axios) => {
  const url = `${domain}/api/v2/unset_pinned_tournament`
  
  return http.post(url,{'tournament_id': tournament_id,'angler_id':angler_id})
  .then(response => response.data)
  .catch(error => Promise.reject(`Error retrieving big fish: ${error}`))
}